import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CustomDataGrid } from "../../../components/CustomDataGrid";
import baseURL from "../../../config/api";
import DeletePopup from "../../../components/DeletePopup";
import { Menu, MenuItem, Stack } from "@mui/material";
import { delete_Course } from "../../../services/Course";
import useDelete from "../../../hook/useDelete";
import useAuth from "../../../hook/useAuth";
import useConfirm from "../../../hook/useConfirm";
import { ConfirmPopup } from "../../../components/ConfirmPopup";


const filterItems = [
    {
        id: 0,
        label: "Course Name",
    }
]

export const Courses = () => {
    const { auth }: any = useAuth();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [filterValue, setFilterValue] = useState(0);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [loading, setLoading] = useState(true);
    const columns: GridColDef[] = [
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link to="/admin/courses/editcourses" state={params?.id} className="underline text-[#0000ff]">
                        {params?.value}
                    </Link>
                );
            },
        },
        {
            field: "courseCategoryName",
            headerName: "Course Category",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "isPublished",
            headerName: "Published",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "createdBy",
            headerName: "Created By",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "action",
            headerName: "Actions",
            type: "actions",
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    showInMenu={true}
                    icon={null}
                    label="Update"
                    onClick={() => { navigate("/admin/courses/updatecourse", { state: { id: params?.id, title: params.row?.title } }) }}
                />,
                <GridActionsCellItem
                    showInMenu={true}
                    icon={null}
                    label="Delete"
                    onClick={() => { handleDeleteCourse(params.row?.id) }}
                />,

            ]
        }

    ];

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    pageSize: paginationModel?.pageSize,
                };

                setPaginationModel(newPaginationModel);
            }, 1000);
        }

        return () => clearTimeout(timeOutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);


    useEffect(() => {
        if (searchValue !== "") {
            filterApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])


    const filterApiCall = (newPaginationModel: any) => {
        setLoading(true);
        let filterData: any[] = [];
        setLoading(true);
        switch (filterValue) {
            case 0:
                fetch(`${baseURL}courses/GetCoursesReportPagingSearchWithCourseName?courseName=${searchValue}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`)
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data?.courseReportDto?.map((item: any) => {
                            return {
                                ...item,
                                isPublished: item?.isPublished ? "Yes" : "No"
                            };
                        })
                        setSearchTableData(filterData);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
                break;

        }

    }

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                pageSize: paginationModel?.pageSize,
            };

            setPaginationModel(newPaginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            emptySearchApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const emptySearchApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}courses/GetCoursesReportPaging/${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.courseReportDto?.map((item: any) => {
                    return {
                        ...item,
                        isPublished: item?.isPublished ? "Yes" : "No"
                    };
                })

                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });


    }

    const handleDeleteCourse = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this course?`,
                isDelete: (callback: any) => {
                    delete_Course(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            callback();
                            const newPaginationModel = {
                                page: 0,
                                pageSize: paginationModel?.pageSize,
                            };

                            setPaginationModel(newPaginationModel);
                        })
                        .catch(error => {
                            console.log(error);
                            callback();

                            setConfirmData({
                                title: 'Warning',
                                summary: error.response.data,
                                confirmBtn: 'Ok',
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            });

                            setConfirmPopup(true);
                        });
                }
            });
        }
    }

    return (
        <>
            <div className="w-full p-4 bg-white rounded-md">
                <div className="w-full">
                    <div className="flex items-center justify-end py-2">
                        <div className="flex items-center gap-2.5">
                            <button className={`px-[8px] py-[6px] bg-primary rounded-lg border text-white flex items-center gap-1.5`}
                                onClick={() => navigate("/admin/courses/addcourse")}
                            >
                                <span className="material-symbols-outlined text-[25px] font-light">
                                    add
                                </span>
                                <span className="text-xs font-medium">Course</span>
                            </button>

                        </div>
                    </div>
                    <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 p-4 border-b border-[#E4E7EC]">

                            <div className="flex items-center gap-1.5">
                                <h2 className="text-lg max-md:text-sm font-semibold text-[#1D2939]">Courses</h2>
                            </div>

                            {/* ↪ Filter + Search responsive container */}
                            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto">

                                {/* Filter Button */}
                                <div>
                                    <button
                                        className="flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid w-full sm:w-auto"
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClick}
                                    >
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                            justifyContent="center"
                                            width="100%"
                                        >
                                            <span className="text-[14px] font-medium text-black-rgba w-full">
                                                {selectedFilter}
                                            </span>
                                            {open ? (
                                                <span className="material-symbols-outlined text-[25px] font-extralight">
                                                    keyboard_arrow_up
                                                </span>
                                            ) : (
                                                <span className="material-symbols-outlined text-[25px] font-extralight">
                                                    keyboard_arrow_down
                                                </span>
                                            )}
                                        </Stack>
                                    </button>

                                    {/* MUI Menu stays same */}
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        slotProps={{
                                            paper: {
                                                sx: { width: 170 }
                                            }
                                        }}
                                    >
                                        {filterItems?.map((filter, index) => (
                                            <MenuItem
                                                key={index}
                                                sx={{ fontSize: "12px", marginBlock: "0px" }}
                                                onClick={() => {
                                                    setSelectedFilter(filter.label);
                                                    setFilterValue(filter.id);
                                                    setAnchorEl(null);
                                                }}
                                            >
                                                <span className="text-[16px] font-medium text-black-rgba">
                                                    {filter.label}
                                                </span>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </div>

                                {/* Search Box — full width on mobile */}
                                <div className="flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border shadow-sm w-full sm:w-60">
                                    <span className="material-symbols-outlined text-[25px] font-light text-black-rgba">
                                        search
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="border-none outline-none w-full bg-transparent"
                                        onChange={(e) => setSearchValue(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <CustomDataGrid
                            filteredRows={searchTableData}
                            columns={columns?.map(col => ({
                                ...col,
                                headerClassName: "bg-[#F9FAFB]",
                            }))}
                            loading={loading}
                            totalLength={totalLength}
                            paginationModel={paginationModel}
                            setPaginationModel={setPaginationModel}
                        />
                    </div>
                </div>

            </div>

            <DeletePopup />
            <ConfirmPopup />
        </>

    )
}